import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {
    width: '100%',
  },
  row: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },

  inputWrapper: {
    flex: 1,
    width: '100%',
    minHeight: 48,
    borderWidth: 1,
    borderColor: '#E0E0E0',
    borderRadius: 8,
    backgroundColor: '#FFF',
    justifyContent: 'center',
  },

  inputFocusable: {
    flex: 1,
    width: '100%',
    minHeight: 48,
    justifyContent: 'center',
  },

  inputSlot: {
    flex: 1,
    width: '100%',
    minWidth: 0,
    minHeight: 48,
    justifyContent: 'center',
  },

  input: {
    width: '100%',
    paddingHorizontal: 12,
    paddingVertical: 0,
    minHeight: 48,
    // fontSize: 13,
    fontSize: 12,
    color: '#1E1E1E',
    backgroundColor: 'transparent',
    borderWidth: 0,
    textAlignVertical: 'center',
    includeFontPadding: false,
  },
  inputWrapperFocused: {
    borderWidth: 2,
    borderColor: '#1E1E1E',
  },
  inputWrapperError: {
    borderWidth: 2,
    borderColor: '#900B09',
  },
  deleteBtn: {
    minHeight: 48,
    minWidth: 48,
    padding: 10,
    borderWidth: 1,
    borderColor: '#E0E0E0',
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  errorText: {
    fontSize: 12,
    color: '#900B09',
    fontWeight: '400',
    marginTop: 4,
  },
  trashIcon: {
    color: '#1D1B20',
    fontSize: 22,
    fontWeight: 'bold',
  },
});
